import { render, staticRenderFns } from "./IndexAd.vue?vue&type=template&id=729de8b0&scoped=true&"
import script from "./IndexAd.vue?vue&type=script&lang=js&"
export * from "./IndexAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729de8b0",
  null
  
)

export default component.exports